import { takeLatest, put, call } from 'redux-saga/effects';

import { history, path, storage } from '@commons';
import { httpAuthService } from '@commons';

import {
  CREATE_ONBOARDING_NOVA_CONTA,
  CREATE_ONBOARDING_NOVA_CONTA_PENDING,
  CREATE_ONBOARDING_NOVA_CONTA_SUCCESS,
  CREATE_ONBOARDING_NOVA_CONTA_FAILURE,
  UPDATE_SESSION_USER,
  findUserAuthResumed,
} from '@handler';

import {AlertWarning, AlertError } from '@components/common/AlertToast';


const cadastrarNovaConta = async (values) => {
  await httpAuthService.registerNewAccountScheme(values);
}

const atualizaUsuarioSchemas = async (id) => {
  let user = await findUserAuthResumed(id)
  httpAuthService.updateSesssionUser(user);
  return user;
}

function* sagaCreateOnboardingNovaConta(action) {
  yield put({ type: CREATE_ONBOARDING_NOVA_CONTA_PENDING });

  try {
    let user = JSON.parse(storage.get(path.sessionUser));
    delete action.data.confirm;

    action.data = {
      ...action.data,
      'nomeConta': action.data.multiFarm && !action.data.unifiedControl ? action.data.nomeConta : action.data.fazendas[0].nomeFazenda,
      'idClienteAgrareGrupo': 1,
      'tipoCliente': 'PRODUTOR',
      'criarDominio': true,
      'idUserAdmin': user.id,
      'nomeResponsavelConta': user.name,
      'emailUserAdmin': user.email,
      'emailPrincipal': user.email,
      'whatsApp': user.whatsApp,
      'identificationCodeWhiteLabel': user.identificationCodeWhiteLabel,
      'idPartnerWhiteLabel': user.idPartnerWhiteLabel,
    }

    yield call(cadastrarNovaConta, action.data);

    var newUser = yield call(atualizaUsuarioSchemas, user.id);

    yield put({ type: UPDATE_SESSION_USER, user: newUser });
    yield put({ type: CREATE_ONBOARDING_NOVA_CONTA_SUCCESS, registro: action.data });

    if (user?.perfil === 'ESTUDANTE_PESQUISA') {
      history.push('/home');
    } else {
      history.push('/pos-onboarding');
    }  

    swal({
      title: 'Conta criada com sucesso!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    })
    
  } catch (error) {
    yield put({ type: CREATE_ONBOARDING_NOVA_CONTA_FAILURE, registro: action.data });

    if (error.text !== undefined && error.text !== null && error.text !== '') {
      AlertWarning(error.text);
    } else {
      AlertError('Falha ao criar nova conta. Tente novamente em instantes...');
    }

    history.push('/home');
  }
}

export default function* watchCreateOnboardingNovaConta() {
  yield takeLatest(CREATE_ONBOARDING_NOVA_CONTA, sagaCreateOnboardingNovaConta);
}
